export default "__VITE_ASSET__D30L32D2__"